export default __webpack_public_path__ + "static/media/Aura-Egg__16.58a7e5ea.png";